import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ResetPasswordPage } from '@/features/auth/pages/ResetPasswordPage';

// The API's reset email links here: `?token=&username=`.
export const Route = createFileRoute('/reset-password')({
  validateSearch: z.object({
    token: z.string().optional().catch(undefined),
    username: z.string().optional().catch(undefined),
  }),
  component: ResetPasswordPage,
});
